export default "__VITE_ASSET__8$nSy3Js__"